module.exports = __webpack_public_path__ + "static/media/wellbeing.855e590a.png";